
export default {
    tipoVagas: [],
    tipoVaga: {}
}